const BRANDBOOK_ID = 'brandbook-module'

export default BRANDBOOK_ID
